// ** Modules
import React from 'react';

// ** Components
import Loader from '@/components/common/Loader';
import Section from '@/components/common/Section';
import BookingPageGuest from './BookingPageGuest';
import ComponentBlocksHero from '@/components/strapi/Blocks/ComponentBlocksHero';
// import BookingPageAuthenticated from './BookingPageAuthenticated';

// ** Utils
import { useGetEventData } from '@/lib/utils/eventDataUtils';
import { handleEventImage } from '@/utils/domain/eventUtils';

// ** Types
import type { User } from 'next-auth';
import type { UploadFile } from '@/types/graphql';

type EventBookingPageProps = {
	eventId?: string | number;
	currentUser?: User; // <-- Updated to NextAuth User type
	host?: string;
	locale?: string;
	containerSx?: Record<string, unknown>;
	[key: string]: unknown;
};

const EventBookingPage = (props: EventBookingPageProps) => {
	const { eventId, currentUser, host, locale, containerSx, ...rest } = props;

	const { eventById, loading, error } = useGetEventData({
		eventId: eventId ?? '',
		companyId: currentUser?.mainId ? String(currentUser.mainId) : '0'
	});

	if (loading) return <Loader />;

	if (error || !eventById) return <div>Event nicht gefunden.</div>;

	const eventImage = handleEventImage(eventById?.field || 'Seminar');

	return (
		<React.Fragment>
			<ComponentBlocksHero
				__typename="ComponentBlocksHero"
				host={host}
				locale={locale}
				showMenu={true}
				// headline={eventById.title ?? ''}
				heroVariant="Content"
				currentUser={currentUser}
				segmentOverrides={[eventById.title ?? '']}
				heroImage={
					{
						url: eventImage,
						alternativeText: eventById.title ?? 'Hero Image'
					} as UploadFile
				}
				{...rest}
			/>

			<Section containerSx={containerSx}>
				{currentUser ? (
					<BookingPageGuest eventById={eventById} currentUser={currentUser} {...rest} /> // <-- Added currentUser
				) : (
					<BookingPageGuest eventById={eventById} currentUser={currentUser} {...rest} /> // <-- Added currentUser
				)}
			</Section>
		</React.Fragment>
	);
};

export default EventBookingPage;
